<h3 class="text-headline">
  {{ type === 'redeem' ? ('#COUPONS.DIALOGS.CONFIRM.HEADER_REDEEM' | translate) : ('#COUPONS.DIALOGS.CONFIRM.HEADER_CHARGE' | translate)}}
</h3>
<p class="text-body">
  {{ type === 'redeem'
      ? ('#COUPONS.DIALOGS.CONFIRM.BODY_REDEEM' | translate | interpolate:{amount: amount})
      : ('#COUPONS.DIALOGS.CONFIRM.BODY_CHARGE' | translate | interpolate:{amount: amount})
  }}
</p>

<div class="flex flex-row justify-end">
  <button class="soft-button secondary mr-3" (click)="close('CANCEL')">{{ '#COUPONS.DIALOGS.CONFIRM.CANCEL' | translate }}</button>
  <button class="soft-button primary" (click)="close('YES')">{{ '#COUPONS.DIALOGS.CONFIRM.OK' | translate }}</button>
</div>
